import { prefixer, createApiConsts } from '../../../Helpers/constants'

const createPrefixedConst = prefixer('STUN_TURN')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const GET_CONFIG = createPrefixedApiConsts('GET_CONFIG')
